import Vue from "vue/dist/vue.esm.browser.js";
import { Multiselect } from 'vue-multiselect'
import _ from "lodash";

class ChartBreadcrumb extends Charcoal.Admin.Widget {
    constructor(opts) {
        super(opts);

        Charcoal.Admin.Widget.call(this, opts);

        this.widget_id = opts.id || this.widget_id;
        this.$widget = this.element();
        this.containerId = opts.containerId || this.containerId;

        this.mrcs = opts.data.mrcs || this.mrcs;
        this.regions = opts.data.regions || this.regions;

        this.region = opts.data.region || this.region;
        this.mrc = opts.data.mrc || this.mrc;

        this.breadcrumbOptions = opts.data.breadcrumbOptions || this.breadcrumbOptions;
    }

    init() {
        const that = this;
        const hooks = [];

        const regionsOptions = this.breadcrumbOptions?.isRegionalAgent ? {
            allowEmpty: false,
            preselectFirst: true,
            hideSelected: true,
        } : {}

        const mrcsOptions = this.breadcrumbOptions?.isMrcAgent ? {
            allowEmpty: false,
            preselectFirst: true,
            hideSelected: true,
        } : {}

        // Use document event bubling to register charts.
        $('#'+this.containerId).on('pajr:chart-breadcrumb:register', (e, callable) => {
            hooks.push(callable)
        })

        this.vue = new Vue({
            el: '#'+this.widget_id+'-vue',
            components: {
                Multiselect
            },
            template: `
                <div class="chart-breadcrumb-item-container">
                    <multiselect
                        class="chart-breadcrumb-item"
                        @select="selectedRegionChanged"
                        @remove="selectedRegionChanged"
                        v-model="selectedRegion"
                        :options="regions"
                        placeholder="Régions"
                        track-by="id"
                        :multiple="false"
                        label="name"
                        v-bind="regionsOptions"
                        v-if="regions.length > 1"
                    ></multiselect>
                    <span class="chart-breadcrumb-item" v-else>{{ selectedRegion?.name }}</span>
                    <span class="chart-breadcrumb-item-separator">/</span>
                    <multiselect
                        class="chart-breadcrumb-item"
                        @select="selectedMrcChanged"
                        @remove="selectedMrcChanged"
                        v-model="selectedMrc"
                        :options="filteredMrcs"
                        placeholder="Territoire"
                        track-by="id"
                        label="name"
                        v-bind="mrcsOptions"
                        v-if="mrcs.length > 1"
                        :disabled="!selectedRegion"
                    ></multiselect>
                    <span class="chart-breadcrumb-item" v-else>{{ selectedMrc?.name }}</span>
                </div>

            `,
            data: {
                mrcs: this.mrcs,
                regions: this.regions,
                selectedRegion: this.region,
                selectedMrc: this.mrc,
                regionsOptions: regionsOptions,
                mrcsOptions: mrcsOptions,
            },
            computed: {
                filteredMrcs() {
                    return this.mrcs.filter(mrc => mrc.region.id === this.selectedRegion?.id)
                }
            },
            methods: {
                selectedRegionChanged(region) {
                    this.selectedMrc = null
                    this.triggerHooks()
                },
                selectedMrcChanged(mrc) {
                    this.triggerHooks()
                },
                triggerHooks() {
                    hooks.forEach(hook => hook({
                        mrc: this.selectedMrc,
                        region: this.selectedRegion,
                    }))
                }
            }
        })
    }
}

Charcoal.Admin.Widget_Paj_Chart_Breadcrumb = ChartBreadcrumb
